import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

let adobeScriptUrl = "";
if (window.location.origin.indexOf("emissionscalculators.walmart.com") !== -1 ||
  window.location.origin.indexOf("walmartsustainabilityhub.calculators.walmart.com") !== -1) {
  adobeScriptUrl = "https://assets.adobedtm.com/a49994c1c918/9ceae4ba8d32/launch-63c4207c6364.min.js";
} else if (window.location.origin.indexOf("emissionscalculators.qa.walmart.com") !== -1 ||
  window.location.origin.indexOf("walmartsustainabilityhub.calculators.qa.walmart.com") !== -1) {
  adobeScriptUrl = "https://assets.adobedtm.com/a49994c1c918/9ceae4ba8d32/launch-abf8420ff3cc-staging.min.js";
} else {
  adobeScriptUrl = "https://assets.adobedtm.com/a49994c1c918/9ceae4ba8d32/launch-31157eaf8efe-development.min.js";
}


if (adobeScriptUrl) {
  const script = document.createElement('script');
  script.src = adobeScriptUrl;
  script.setAttribute('async','');
  document.getElementsByTagName('head')[0].appendChild(script);
}

(async () => {
  const URL = `${environment.serviceURL}/general/api/general/innovation-key`;
  const response = await fetch(URL);
  const config = await response.json();
  if (config) {
    sessionStorage.setItem("innovationKey", config.innovationKey);
  }

  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
})();
